// לקוח API דק. כל השגיאות מוחזרות כ-ApiError עם הודעה בעברית מהשרת.
export class ApiError extends Error {
  constructor(public status: number, message: string, public details?: unknown) { super(message); }
}

async function req<T>(method: string, url: string, body?: unknown): Promise<T> {
  const init: RequestInit = { method, credentials: 'same-origin', headers: {} };
  if (body instanceof FormData) init.body = body;
  else if (body !== undefined) { init.body = JSON.stringify(body); (init.headers as any)['content-type'] = 'application/json'; }
  const r = await fetch(url, init);
  const text = await r.text();
  let data: any = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = text; }
  if (!r.ok) {
    if (r.status === 401 && !url.startsWith('/api/auth') && location.pathname !== '/login' && location.pathname !== '/set-password') location.href = '/login';
    throw new ApiError(r.status, data?.error ?? `שגיאה ${r.status}`, data?.details);
  }
  return data as T;
}

export const api = {
  get: <T = any>(url: string) => req<T>('GET', url),
  post: <T = any>(url: string, body?: unknown) => req<T>('POST', url, body ?? {}),
  patch: <T = any>(url: string, body?: unknown) => req<T>('PATCH', url, body ?? {}),
  put: <T = any>(url: string, body?: unknown) => req<T>('PUT', url, body ?? {}),
  del: <T = any>(url: string) => req<T>('DELETE', url),
  upload: <T = any>(url: string, fd: FormData) => req<T>('POST', url, fd),
};

export interface Job { id: string; type: string; status: 'queued' | 'running' | 'succeeded' | 'failed' | 'canceled'; result: any; error: string | null; progress: any }

/** ממתין לסיום עבודה (polling). onUpdate לקבלת התקדמות. */
export async function waitForJob(jobId: string, onUpdate?: (j: Job) => void, timeoutMs = 10 * 60_000): Promise<Job> {
  const end = Date.now() + timeoutMs;
  let delay = 400;
  while (Date.now() < end) {
    const j = await api.get<Job>(`/api/jobs/${jobId}`);
    onUpdate?.(j);
    if (j.status === 'succeeded' || j.status === 'failed' || j.status === 'canceled') return j;
    await new Promise((r) => setTimeout(r, delay));
    delay = Math.min(2000, delay * 1.4);
  }
  throw new Error('העבודה לא הסתיימה בזמן');
}
